import { useAccountActionPermissions } from "@zapier/client";
import { SortDescriptor, SortDirection } from "@zapier/design-system";

export enum EmptyFolderTableTypes {
  EmptySearchResults = "EmptySearchResults",
  NoFolders = "NoFolders",
  UpgradeForSharing = "UpgradeForSharing",
}

interface Input {
  sortDescriptor: SortDescriptor;
  order: string | undefined;
  searchQuery: string | null | undefined;
  hasFolders: boolean;
  isLoading: boolean;
  selectedOwner: string | null | undefined;
}

export function useShowEmptyFolderTable({
  sortDescriptor,
  order,
  searchQuery,
  hasFolders,
  isLoading,
  selectedOwner,
}: Input) {
  const { isSharingEnabled } = useAccountActionPermissions();

  // update sortDescriptor if order is provided
  if (order) {
    sortDescriptor.column = order.replace("-", "");
    sortDescriptor.direction = (
      order[0] === "-" ? "descending" : "ascending"
    ) as SortDirection;
  }

  /* Empty Search OR Owner Filter */
  if ((searchQuery || selectedOwner) && !hasFolders && !isLoading) {
    return EmptyFolderTableTypes.EmptySearchResults;
  }

  /* Empty folders list */
  if (!searchQuery && !hasFolders && !isLoading) {
    if (!isSharingEnabled) {
      return EmptyFolderTableTypes.UpgradeForSharing;
    }
    return EmptyFolderTableTypes.NoFolders;
  }
  return;
}
